module.exports = __webpack_public_path__ + "ebdfa24cb411ba3016abd1c3ea5746e5.woff2";